export const FORM = 'ModalTypes.FORM'
export const ALERT = 'ModalTypes.ALERT'
export const FULLSCREEN = 'ModalTypes.FULLSCREEN'

export default {
    FORM,
    ALERT,
    FULLSCREEN,
}
